import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { connect } from 'react-redux';

import { Button, PasswordRecover, UsernameRecover } from '../../components/';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { legacyPasswordRecover, setValidationError } from '../../migrate/actions';
import { openModal } from '../../components/modal/actions';

const ForgotInfoModal = ({ history, legacyPasswordRecover, openModal, type }) => {
  const modalContent =
    type === 'username' ? (
      <UsernameRecover isModal />
    ) : (
      <PasswordRecover passwordRecover={legacyPasswordRecover} history={history} isLegacy isModal />
    );

  const handleClick = () => {
    openModal({
      type: 'custom',
      element: modalContent
    });
  };

  return (
    <>
      <Button
        type='button'
        textLink
        matchCase
        extraClassName='p0-sm body-4'
        onClick={handleClick}
        data-desc={`forgotInfoModal__button_${type}`}
        key='testing'
      >
        <TranslatedCopy id={type === 'username' ? 'global.forgot.username' : 'global.forgot.password'} />
      </Button>
    </>
  );
};

ForgotInfoModal.defaultProps = {
  history: null
};

ForgotInfoModal.propTypes = {
  openModal: PropTypes.func.isRequired,
  legacyPasswordRecover: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history,
  type: PropTypes.string.isRequired
};

const connector = connect(() => ({}), {
  legacyPasswordRecover,
  openModal,
  setValidationError
});

export default connector(ForgotInfoModal);
